import type { SVGProps } from 'react'
const LineCreditCards = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M6.75 4h13.5c.965 0 1.75.785 1.75 1.75v9.5c0 .965-.785 1.75-1.75 1.75H6.75C5.785 17 5 16.215 5 15.25v-9.5C5 4.785 5.785 4 6.75 4m13.5 1.5H6.75c-.14 0-.25.11-.25.25v2.245h14V5.75c0-.14-.11-.25-.25-.25m-13.5 10h13.5c.14 0 .25-.11.25-.25V9.5h-14v5.75c0 .14.11.25.25.25M3.5 7v10.25c0 .69.56 1.25 1.25 1.25H19.5V20H4.75A2.755 2.755 0 0 1 2 17.25V7z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineCreditCards }
